import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import "./index.css";
import "./lib/install";
import { App } from "./App";
import { ConfirmProvider, ToastProvider } from "./components/ui";
import { TillProvider } from "./lib/till-context";

// The store's palette, chosen per site at deploy (sites.json "palette").
const palette = import.meta.env.VITE_PALETTE as string | undefined;
if (palette) document.documentElement.dataset.pack = palette;

const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <ToastProvider>
          <TillProvider>
            <ConfirmProvider>
              <App />
            </ConfirmProvider>
          </TillProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);

// Installable as an app (manifest + this worker); the Install button comes from lib/install.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}
